import React, { ReactNode } from "react";
import WarningIcon from "../../images/warning.jpeg";
import InformationIcon from "../../images/information-icon.png";
import { useEnumStrings } from "../enumStrings";
import ActionDialog from "./ActionDialog";

interface ComingSoonDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: ReactNode;
  subtitle?: string;
  useInfoIcon?: boolean;
  maxWidth?: string;
}

const ComingSoonDialog: React.FC<ComingSoonDialogProps> = ({
  open,
  onClose,
  title,
  description,
  subtitle,
  useInfoIcon = false,
  maxWidth = "420px",
}) => {
  const enumStrings = useEnumStrings();

  const iconSrc = useInfoIcon ? InformationIcon : WarningIcon;

  const descriptionNode = subtitle ? (
    <>
      <div style={{ fontWeight: 700, color: "#24272C", marginBottom: "16px" }}>
        {subtitle}
      </div>
      <div>{description ?? enumStrings.common?.comingSoonDesc}</div>
    </>
  ) : (
    description ?? enumStrings.common?.comingSoonDesc
  );

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      icon={<img src={iconSrc} alt="Icon" style={{ width: "80px", height: "80px", borderRadius: useInfoIcon ? 0 : "50%" }} />}
      iconBgColor="transparent"
      iconSize={80}
      title={title ?? enumStrings.common?.comingSoon}
      description={descriptionNode}
      maxWidth={maxWidth}
    />
  );
};

export default ComingSoonDialog;
